import { call, getContext, takeLatest, put } from 'redux-saga/effects';
import { isAxiosError } from 'axios';
import { HTTPStatusCode } from '@as-react/common-types';
import BasketAPI from '../../../api/basket/BasketAPI';
import { BasketActionTypes } from '../../../enums/ActionEnums';
import { basketActions } from '../actions/BasketActions.creators';
export function* checkStockReservation() {
    var _a, _b;
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield call(BasketAPI.checkStockReservation, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createHasUnavailableProductsAction(false));
    }
    catch (error) {
        if (isAxiosError(error)) {
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === HTTPStatusCode.BadRequest && ((_b = error.response.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                yield put(basketActions.createHasUnavailableProductsAction(true));
            }
        }
    }
}
export function* checkStockReservationSaga() {
    yield takeLatest(BasketActionTypes.CHECK_STOCK_RESERVATION, checkStockReservation);
}
